import React, {Component} from 'react';
import {Button, Card, CardContent, CardHeader} from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

class CustomCardLinkComponent extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            map: this.props.map
        };
    }

    render() {
        let links = [];
        let counter = 0;
        this.props.map.forEach(function (value, key) {
            let component = <Button variant={"text"} color={"secondary"}
                                    endIcon={key !== '' ? <OpenInNewIcon sx={{marginLeft: '100%'}}/> : null}
                                    fullWidth onClick={() => {
                if (key !== '')
                    window.open(key, '_blank', 'noopener,noreferrer');
            }} key={key + counter.toString()}>
                {value}
            </Button>
            links.push(component);
            counter++;
        });

        return (
            <Card sx={{
                minWidth: 350,
                background: this.props.background,
                color: 'white'
            }}>
                <CardHeader sx={{fontSize: 14, color: 'white'}} title={<b>{this.props.title}</b>}
                            subheaderTypographyProps={{color: 'lightGrey'}} subheader={this.props.subheader}/>
                <CardContent>
                    {links}
                </CardContent>
            </Card>
        )
    }
}

export default CustomCardLinkComponent;